import { render } from "./Main.vue?vue&type=template&id=2a5d9e70"
const script = {}

import exportComponent from "D:\\Light-work-sprintoff\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__